import { useQuery } from '@tanstack/react-query';
import {
  accountQuery,
  playerProfileQuery,
  profileDisplayName,
  profileInitials,
  useAuthSession,
} from '@/api';
import { cn } from '@/lib/cn';
import { MenuBalanceCard } from '@/shell/MenuBalanceCard';
import { AccountNav } from './AccountNav';
import { AccountPlayerCard } from './AccountPlayerCard';
import { profileNavItems } from './profileNav';

export interface AccountSidebarProps {
  className?: string;
}

export function AccountSidebar({ className }: AccountSidebarProps) {
  const { user } = useAuthSession();
  const { data: account } = useQuery(accountQuery());
  const machineGuid = user?.Guid ?? null;
  const { data: profile } = useQuery(playerProfileQuery(machineGuid));

  const source = profile ?? {
    FirstName: undefined,
    LastName: undefined,
    Username: user?.Username ?? user?.Name,
  };
  const displayName = profileDisplayName(source) || user?.Name || user?.Username || '';
  const username = profile?.Username ?? user?.Username ?? '';
  const initials = profileInitials(source);
  const items = profileNavItems(account, user);

  return (
    <aside
      className={cn(
        'flex w-60 shrink-0 flex-col items-stretch gap-3 overflow-hidden bg-bg-canvas px-3 py-4',
        className,
      )}
    >
      {/* Header stays shrink-0 so the full balance breakdown is never clipped by nav. */}
      <div className="flex shrink-0 flex-col gap-3">
        <AccountPlayerCard displayName={displayName} username={username} initials={initials} />
        <MenuBalanceCard />
      </div>
      {/* Nav scrolls in remaining viewport height when the balance card expands. */}
      <AccountNav items={items} className="min-h-0 flex-1 overflow-y-auto [scrollbar-gutter:stable]" />
    </aside>
  );
}
